import { ReturnIntegrationProvider } from "@redotech/crdb-enums/returns/return-integration-provider";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const metricsTableRowSchema = z.object({
  teamId: z.string(),
  teamName: z.string().optional(),
  integration: z.enum(ReturnIntegrationProvider),
  capturedAt: z.date(),
  staleRmaReturnsCount: z.number().int().min(0),
  automationRmaProcessedCount: z.number().int().min(0),
});

export type MetricsTableRow = z.infer<typeof metricsTableRowSchema>;

const sortKeySchema = z.enum([
  "captured_at",
  "stale_rma_returns_count",
  "automation_rma_processed_count",
  "integration",
]);

const sortDirectionSchema = z.enum(["asc", "desc"]);

export const getReturnIntegrationMetricsTable = unaryRpc({
  name: "getReturnIntegrationMetricsTable" as const,
  input: z.object({
    pageNumber: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(100).default(50),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    integrations: z.array(z.enum(ReturnIntegrationProvider)).optional(),
    accountId: z.string().optional(),
    teamId: z.string().optional(),
    minStaleCount: z.number().int().min(0).optional(),
    sort: z
      .object({ key: sortKeySchema, direction: sortDirectionSchema })
      .optional(),
  }),
  output: z.object({
    rows: z.array(metricsTableRowSchema),
    totalCount: z.number().int().min(0),
  }),
});

export type GetReturnIntegrationMetricsTableInput = z.infer<
  typeof getReturnIntegrationMetricsTable.input
>;
export type GetReturnIntegrationMetricsTableOutput = z.infer<
  typeof getReturnIntegrationMetricsTable.output
>;
export type SortKey = z.infer<typeof sortKeySchema>;
export type SortDirection = z.infer<typeof sortDirectionSchema>;
